import { Button, PageContent, PageHeader } from '@/components';
import { isPS } from '@/utils';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectsPageDynamicLink } from '../../../_components/ProjectsPageDynamicLink';

interface ProjectLedgerPageLayoutProps {
  onPrintPdf: () => void;
  children: ReactNode;
}

/**
 * プロジェクト帳票ページの共通レイアウト
 */
export const ProjectLedgerPageLayout: FC<ProjectLedgerPageLayoutProps> = ({
  onPrintPdf,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={
          isPS() ? t('preview-print-page') : t('preview-report-projects-page')
        }
        breadcrumbs={[
          { title: <ProjectsPageDynamicLink /> },
          {
            title: t('project-details-page'),
            href: isPS()
              ? `${location.pathname.replace('/public-site', '').split('/').slice(0, -1).join('/')}`
              : `${location.pathname.split('/').slice(0, -1).join('/')}`,
          },
          {
            title: isPS()
              ? t('preview-print-page')
              : t('preview-report-projects-page'),
          },
        ]}
        buttons={
          <Button type="primary" onClick={onPrintPdf}>
            {t('export-ledger')}
          </Button>
        }
      />
      <PageContent>{children}</PageContent>
    </>
  );
};
